import { Camera } from '@phosphor-icons/react';

import pt from '../../locales/pt';

/**
 * Card hero de estado vazio — só o bloco gradiente (badge + título). O
 * parágrafo de apoio, a nota sage e o CTA vivem no `content` da página
 * (`SelfieHistory.jsx`), como o `.pen` os empilha.
 * .pen: dJcvz (ds/selfie/empty-hero)
 */
export function SelfieEmptyHero() {
  return (
    <div
      data-ds-id="ds/selfie/empty-hero"
      className="relative flex flex-col gap-space-4 overflow-hidden rounded-ds-xl bg-gradient-to-br from-sage-500 to-sage-800 p-space-5"
    >
      <span
        className="absolute -right-[46px] -top-[46px] size-[150px] rounded-ds-full bg-white/10"
        aria-hidden
      />
      <span
        className="absolute -bottom-4 -left-[34px] size-[120px] rounded-ds-full bg-white/[0.08]"
        aria-hidden
      />
      <span className="relative flex size-14 items-center justify-center rounded-ds-lg bg-on-hero-track">
        <Camera className="size-7 text-on-hero" weight="regular" aria-hidden />
      </span>
      <h2 className="relative font-display text-type-display-metric font-bold leading-[1.2] tracking-[-0.48px] text-on-hero">
        {pt.snapshots.history.empty.title}
      </h2>
    </div>
  );
}

export default SelfieEmptyHero;
